module.exports = __webpack_public_path__ + "img/xiaomi12timage3.3c022b2d.png";